<template>
	<div class="text-left pt-1"> 
		<h6 class="mb-0">{{nickname}}</h6>
		<div style="padding: 8px; width: 100%; height: 120px">
			<b-row class="no-gutters">
				<b-col cols=6>
					<video ref="video" style="background-color: black; max-width: 100%; max-height: 100%; margin: auto" :muted="muted" />
				</b-col>
				<b-col cols=6>
					<div style="height: 120px; padding: 0px 8px">
						<b-btn block variant="danger" size=sm @click="hangup"><i class="far fa-times-circle pr-1"></i>Disconnect</b-btn>
						<b-btn block size=sm :variant="isAdmin? 'secondary' : 'primary'" class="mt-1" @click="sendAdmin(); isAdmin = !isAdmin">
							<i class="fas fa-key pr-1"></i> {{ isAdmin? 'Remove' : 'Make' }} Admin
						</b-btn>
						<b-btn block v-if="!isAdmin" size=sm :variant="hasControl? 'secondary': 'success'" class="mt-1" @click="sendMicroscopeControl(); hasControl = !hasControl">
							<i class="fas fa-arrows-alt pr-1"></i> {{ hasControl? 'Remove' : 'Give' }} Control
						</b-btn>
					</div>
				</b-col>
			</b-row>
		</div>

		<div class="my-2" style="background-color: gainsboro; height: 1px" />
	</div>
</template>

<script>
export default {
	props: ['callerId', 'stream', 'nickname', 'currentZ', 'muted', 'admin'],

	data() {
		return {
			isAdmin: this.admin,
			hasControl: this.admin
		}
	},

	mounted() {
		easyrtc.setVideoObjectSrc(this.$refs.video, this.stream);
	},

	methods: {
		hangup() {
			this.$emit('hangup');
		},

		sendAdmin() {
			easyrtc.sendDataWS(this.callerId, 'grant-admin');
		},

		sendMicroscopeControl() {
			easyrtc.sendDataWS(
				this.callerId,
				'microscope-grant-control',
				this.currentZ
			);
		}
	}
};
</script>